import React, {memo, useCallback, useEffect, useState} from 'react';
import {getPayoutCurrent, getPayouts, getPayoutsCsv, getPayoutsXml} from '../../actions/paymentActions';
import memoize from 'memoize-one';
import {Link} from 'react-router-dom';
import {CardBody, CardHeader, Col, Fade} from 'reactstrap';
import DropdownList from 'react-widgets/lib/DropdownList';
import DataTable from 'react-data-table-component';
import DataTableProgressComponent from '../../shared/components/widget/DataTableProgressComponent';
import DataTableNoDataComponent from '../../shared/components/widget/DataTableNoDataComponent';
import {getInvoiceId} from '../../actions/invoicesList';

function InvoicesView({ match : { params : { id } } }) {
    const [payouts, setPayouts] = useState([]);

    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        fetchData()
    }, [ id ]);

    const fetchData = useCallback(async () => {
        await setLoading(true);
        const data = await getInvoiceId(id);

        console.log(data, 'data');
        await setPayouts(data);
        await setLoading(false);
    }, [ id ]);

    const columns = memoize((handleEditClick, handleShowClick) => [
        {
            name: 'ID',
            selector: 'id',
            sortable: false,
            center: true,
            grow: 0
        },
        {
            name: 'Booked at',
            selector: 'booked_at',
            sortable: false,
            center: false,
            grow: 1,
            cell: row => (
                row.booked_at.split('T')[0]
            )
        },
        {
            name: 'Currency',
            selector: 'currency',
            sortable: false,
            right: false,
            grow: 1
        },
        {
            name: 'Net amount',
            selector: 'net_amount',
            sortable: false,
            right: false,
            grow: 1
        },
        {
            name: 'Amount',
            selector: 'amount',
            sortable: false,
            right: false,
            grow: 1
        },
        {
            name: 'Online',
            selector: 'online',
            sortable: false,
            right: false,
            grow: 1,
            cell: row => (
                row.online ? 'online' : 'offline'
            )
        },


        // {
        //     name: 'Download',
        //     selector: 'download',
        //     sortable: false,
        //     right: false,
        //     grow: 1,
        //     cell: row => (
        //         <div>
        //             <a
        //                 // href={sepa?.csv?.href} download={sepa?.csv?.download} title={sepa?.csv?.download ? '1.csv' : 'no file'}
        //                 onClick={handleCsv}
        //                 style={{
        //                     cursor: 'pointer'
        //                 }}>
        //                 <Sepa />
        //             </a>
        //
        //             <a
        //                 style={{
        //                     cursor: 'pointer'
        //                 }}
        //                 onClick={handleXml}>
        //                 <XmlFile />
        //             </a>
        //         </div>
        //     )
        // }
    ]);


    const { sales: items = {} } = payouts;

    return (
        <div className={'card'}>
            <div style={{
                position: 'relative'
            }}>
                <Fade in={items?.length > 0 && !loading}>
                    { <div id="payments-table">
                        <CardBody>
                            {/*<Col>*/}
                            {/*    <h4 style={{*/}
                            {/*        marginBottom: '20px'*/}
                            {/*    }}>Details view for payout</h4>*/}
                            {/*</Col>*/}
                            <DataTable
                                title={'Below the transactions\n'}
                                columns={columns()}
                                data={items}
                                theme="solarized"
                                sortServer
                                progressComponent={<DataTableProgressComponent />}
                                noDataComponent={<DataTableNoDataComponent />}
                            />
                        </CardBody>
                    </div> }
                </Fade>

                {
                    loading &&  <span className={'span-payouts'}>
                        Loading ...
                    </span>
                }

                <Fade in={!items?.length > 0 && !loading}>
                    <span className={'span-payouts'}>
                         Payouts not yet
                    </span>
                </Fade>
            </div>
        </div>
    );
}

export default memo(InvoicesView);